import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { api, auth } from "./lib/api";
import { useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewCase from "./pages/NewCase";
import Recording from "./pages/Recording";
import Transcript from "./pages/Transcript";
import Results from "./pages/Results";
import CaseDetail from "./pages/CaseDetail";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import GeoAnalytics from "./pages/GeoAnalytics";
import ResetPassword from "./pages/ResetPassword";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";

// Protected route wrapper
const ProtectedRoute = ({ children, adminOnly = false, superAdminOnly = false }) => {
  if (!auth.isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  if (superAdminOnly && !auth.isSuperAdmin()) {
    return <Navigate to="/" replace />;
  }
  if (adminOnly && !auth.isAdmin()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// Track page visits
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if logged in
    if (auth.isLoggedIn()) {
      api.trackActivity({
        action: "page_view",
        path: location.pathname + location.search,
      }).catch(err => {
        // Silent fail for tracking
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-slate-50">
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/new-case" element={<ProtectedRoute><NewCase /></ProtectedRoute>} />
            <Route path="/case/:caseId/record" element={<ProtectedRoute><Recording /></ProtectedRoute>} />
            <Route path="/case/:caseId/transcript" element={<ProtectedRoute><Transcript /></ProtectedRoute>} />
            <Route path="/case/:caseId/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
            <Route path="/case/:caseId" element={<ProtectedRoute><CaseDetail /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute superAdminOnly><Settings /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
            <Route path="/analytics/geo" element={<ProtectedRoute adminOnly><GeoAnalytics /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
